<template>
    <div class="w-full landing flex flex-col gap-4">
        <Navbar />
        <div class="head-cont mb-6">
            <h1 class="text-5xl font-semibold">Decast Infrastructure</h1>
        </div>

        <div class="basic__section basic__section__1 flex w-full justify-center items-center py-16">
            <div
                class="max-w-7xl w-full lg:px-16 md:px-6 p-4 flex flex-col lg:grid lg:grid-flow-col grid-cols-2 justify-between items-start lg:gap-4 gap-16">
                <div class="flex flex-col text-grey gap-4 w-full col-span-1 lg:order-last lg:justify-end lg:items-end">
                    <div class="flex-col flex md:w-10/12 sm:w-10/12">
                        <div class="w-24 h-24 relative mb-4 pr-2">
                            <img class="w-full h-full" src="@/assets/images/landing/infra/infraicon1.svg" />
                        </div>
                        <h5 class="lg:text-5xl text-4xl text-grey font-semibold">
                            Collaborative Edge Computing 'CEC' Infra as a Service
                        </h5>
                        <div class="w-64 my-4 h-2 rounded-full" style="background-color: #d7df23"></div>
                        <p class="text-base text-grey font-normal">
                            Utilize the network for deploying dapps over to the same infra that supports CAST.
                        </p>
                    </div>
                </div>
                <div class="basic__section__img w-full md:w-auto relative flex object-cover col-span-1 justify-start">
                    <img class="rounded-lg object-cover sm:w-10/12 w-full" src="@/assets/images/landing/infra/infra1.png" />
                </div>
            </div>
        </div>

        <div class="basic__section basic__section__2 flex w-full justify-center items-center py-16">
            <div
                class="max-w-7xl w-full lg:px-16 md:px-6 p-4 flex flex-col lg:grid lg:grid-flow-col grid-cols-2 justify-between items-start lg:gap-4 gap-16">
                <div class="flex flex-col text-grey gap-4 w-full col-span-1">
                    <div class="w-24 h-24 relative mb-4 pr-2">
                        <img class="w-full h-full" src="@/assets/images/landing/infra/infraicon2.svg" />
                    </div>
                    <h5 class="lg:text-5xl text-4xl text-grey font-semibold md:w-10/12 sm:w-10/12">
                        Run a node to support the network and mine tokens.
                    </h5>
                    <div class="w-64 my-4 h-2 rounded-full" style="background-color: #d7df23"></div>
                    <p class="text-base text-grey font-normal md:w-10/12 sm:w-10/12">
                        An on-demand framework which is strengthened by independent node operators throughout the world.
                        DCEC is open-source cloud for users use and sell spare computing resources securely and efficiently.
                    </p>
                </div>
                <div class="basic__section__img w-full md:w-auto relative flex object-cover col-span-1 justify-end">
                    <img class="rounded-lg object-cover sm:w-10/12 w-full" src="@/assets/images/landing/infra/infra2.png" />
                </div>
            </div>
        </div>

        <div class="basic__section basic__section__1 flex w-full justify-center items-center py-16">
            <div
                class="max-w-7xl w-full lg:px-16 md:px-6 p-4 flex flex-col lg:grid lg:grid-flow-col grid-cols-2 justify-between items-start lg:gap-4 gap-16">
                <div class="flex flex-col text-grey gap-4 w-full col-span-1 lg:order-last lg:justify-end lg:items-end">
                    <div class="flex-col flex md:w-10/12 sm:w-10/12">
                        <div class="w-24 h-24 relative mb-4 pr-2">
                            <img class="w-full h-full" src="@/assets/images/landing/infra/infraicon3.svg" />
                        </div>
                        <h5 class="lg:text-5xl text-4xl text-grey font-semibold">
                            A network of network operators
                        </h5>
                        <div class="w-64 my-4 h-2 rounded-full" style="background-color: #d7df23"></div>
                        <p class="text-base text-grey font-normal">
                            Choose to control your video infrastructure and run on your own servers to secure you intranet
                            video solution. Now you have the power to own your streams. Naked resources so you can wear your
                            own infrastructure.
                            <br /><br />
                            - Sell your unused resources to others and power the decentralized web,
                            <br /><br />
                            - Buy resources from others and scale your events,
                            <br /><br />
                            - Or use the on-demand network to deploy and run your own Dapps.
                            <br /><br />

                            <span class="font-semibold">Scalable:</span>
                            Rapidly scale and access services around the world.
                            <br /><br />

                            <span class="font-semibold">Economical:</span>
                            Publish your event time and desired rate of access, and providers compete for the selling
                            bandwidth.
                            <br /><br />

                            <span class="font-semibold">Dependable:</span>
                            Built on dependable technologies like Kubernetes and NEAR BOS. Distributed to make redundancies
                            against single point of failure.
                        </p>
                    </div>
                </div>
                <div class="basic__section__img w-full md:w-auto relative flex object-cover col-span-1 justify-start">
                    <img class="rounded-lg object-cover sm:w-10/12 w-full" src="@/assets/images/landing/infra/infra3.png" />
                </div>
            </div>
        </div>

        <div class="basic__section basic__section__2 flex w-full justify-center items-center py-16">
            <div
                class="max-w-7xl w-full lg:px-16 md:px-6 p-4 flex flex-col lg:grid lg:grid-flow-col grid-cols-2 justify-between items-start lg:gap-4 gap-16">
                <div class="flex flex-col text-grey gap-4 w-full col-span-1">
                    <div class="w-24 h-24 relative mb-4 pr-2">
                        <img class="w-full h-full" src="@/assets/images/landing/infra/infraicon4.svg" />
                    </div>
                    <h5 class="lg:text-5xl text-4xl text-grey font-semibold md:w-10/12 sm:w-10/12">
                        Blockchain and Interoperability
                    </h5>
                    <div class="w-64 my-4 h-2 rounded-full" style="background-color: #d7df23"></div>
                    <p class="text-base text-grey font-normal md:w-10/12 sm:w-10/12">
                        - Layer one protocol built using Cosmos SDK that uses Proof-of-Stake consensus to secure its network
                        of decentralized validators.
                        <br /><br />
                        - Storage options with Private, Public, and Decentralized options to store recordings.
                        <br /><br />
                        - Wallet based minimum identity requirements to keep your private data safe and need to know basis.
                    </p>
                </div>
                <div class="basic__section__img w-full md:w-auto relative flex object-cover col-span-1 justify-end">
                    <img class="rounded-lg object-cover sm:w-10/12 w-full" src="@/assets/images/landing/infra/infra4.png" />
                </div>
            </div>
        </div>

        <div class="basic__section basic__section__1 flex w-full justify-center items-center py-16">
            <div
                class="max-w-7xl w-full lg:px-16 md:px-6 p-4 flex flex-col lg:grid lg:grid-flow-col grid-cols-2 justify-between items-start lg:gap-4 gap-16">
                <div class="flex flex-col text-grey gap-4 w-full col-span-1 lg:order-last lg:justify-end lg:items-end">
                    <div class="flex-col flex md:w-10/12 sm:w-10/12">
                        <div class="w-24 h-24 relative mb-4 pr-2">
                            <img class="w-full h-full" src="@/assets/images/landing/infra/infraicon5.svg" />
                        </div>
                        <h5 class="lg:text-5xl text-4xl text-grey font-semibold">
                            Peer 2 Peer and Private
                        </h5>
                        <div class="w-64 my-4 h-2 rounded-full" style="background-color: #d7df23"></div>
                        <p class="text-base text-grey font-normal">
                            - Various nodes provide bandwidth, load-balanced and standby backups to make your event stream
                            dependable and unaffected by single point of failure.
                            <br /><br />
                            - Deploying applications is secure, private, and censorship-proof.
                            <br /><br />
                            - Deploy and communicate directly, without any external dependancies
                        </p>
                    </div>
                </div>
                <div class="basic__section__img w-full md:w-auto relative flex object-cover col-span-1 justify-start">
                    <img class="rounded-lg object-cover sm:w-10/12 w-full" src="@/assets/images/landing/infra/infra5.png" />
                </div>
            </div>
        </div>

        <div class="basic__section basic__section__2 flex w-full justify-center items-center py-16">
            <div
                class="max-w-7xl w-full lg:px-16 md:px-6 p-4 flex flex-col lg:grid lg:grid-flow-col grid-cols-2 justify-between items-start lg:gap-4 gap-16">
                <div class="flex flex-col text-grey gap-4 w-full col-span-1">
                    <div class="w-24 h-24 relative mb-4 pr-2">
                        <img class="w-full h-full" src="@/assets/images/landing/infra/infraicon6.svg" />
                    </div>
                    <h5 class="lg:text-5xl text-4xl text-grey font-semibold md:w-10/12 sm:w-10/12">
                        Infrastructure and Resources
                    </h5>
                    <div class="w-64 my-4 h-2 rounded-full" style="background-color: #d7df23"></div>
                    <p class="text-base text-grey font-normal md:w-10/12 sm:w-10/12">
                        - Infrastructure as a Code powered by SDL. Simple-to-use YAML-based language that lets you create
                        complex deployments.
                        <br /><br />
                        - Runs on Kubernetes, the industry-leading container orchestration system.
                        <br /><br />
                        - Perpetual Storage with lifetime and limitless network storage system. Ideal for large media files,
                        databases, large datasets.
                    </p>
                </div>
                <div class="basic__section__img w-full md:w-auto relative flex object-cover col-span-1 justify-end">
                    <img class="rounded-lg object-cover sm:w-10/12 w-full" src="@/assets/images/landing/infra/infra6.png" />
                </div>
            </div>
        </div>

        <FootSec />
    </div>
</template>

<script>
import Navbar from './Navbar.vue';
import FootSec from './FootSec.vue';
export default {
    components: {
        Navbar,
        FootSec,
    },
};
</script>

<style scoped>
.landing {
    height: auto;
    width: 100%;
    background-image: linear-gradient(180deg, #000, #111, #222);
    font-family: 'Montserrat' !important;
    /* overflow-x: hidden; */
    /* background: -webkit-linear-gradient(to bottom,#302f2f,#222121);
  background: linear-gradient(to bottom,#000000,#000000,#000000,#1d1c1c,#141318,#181a20,#222121);  */
}

.basic__section__1 {
    background-image: url('../assets/images/leftPart.svg');
    background-position: left;
    background-repeat: no-repeat;
    background-size: contain;
}

.basic__section__2 {
    background-image: url('../assets/images/rightPart.svg');
    background-position: right;
    background-repeat: no-repeat;
    background-size: contain;
}

.basic__section__img img {
    box-shadow: 50px 50px 100px -12px rgba(214, 224, 36, 0.1);
    transition: all 0.5s ease-in-out;
}

.basic__section__img img:hover {
    box-shadow: 50px 50px 80px -12px rgba(214, 224, 36, 0.2);
}

.head-cont {
    background-color: #d7df23;
    width: 100%;
    min-height: 25vh;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>